"use client";

import * as React from 'react';
import { Tabs as BaseTabs } from '@base-ui/react/tabs';
import { cn } from '@/lib/utils/cn';

const Tabs = BaseTabs.Root;

const TabsList = React.forwardRef<
  HTMLDivElement,
  Omit<React.ComponentPropsWithoutRef<typeof BaseTabs.List>, 'className'> & { className?: string }
>(({ className, ...props }, ref) => (
  <BaseTabs.List
    ref={ref}
    className={cn('inline-flex h-10 items-center justify-center rounded-control bg-zen-muted p-1 text-zen-text-muted', className)}
    {...props}
  />
));
TabsList.displayName = 'TabsList';

const TabsTrigger = React.forwardRef<
  HTMLElement,
  Omit<React.ComponentPropsWithoutRef<typeof BaseTabs.Tab>, 'className'> & { className?: string }
>(({ className, ...props }, ref) => (
  <BaseTabs.Tab
    ref={ref}
    className={(state) =>
      cn(
        'inline-flex items-center justify-center whitespace-nowrap rounded-control-inner px-3 py-1.5 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-zen-ring disabled:pointer-events-none disabled:opacity-50',
        state.active ? 'bg-zen-surface text-zen-text shadow-sm' : 'text-zen-text-muted',
        className,
      )
    }
    {...props}
  />
));
TabsTrigger.displayName = 'TabsTrigger';

const TabsContent = React.forwardRef<
  HTMLDivElement,
  Omit<React.ComponentPropsWithoutRef<typeof BaseTabs.Panel>, 'className'> & { className?: string }
>(({ className, ...props }, ref) => (
  <BaseTabs.Panel
    ref={ref}
    className={cn('mt-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-zen-ring', className)}
    {...props}
  />
));
TabsContent.displayName = 'TabsContent';

export { Tabs, TabsList, TabsTrigger, TabsContent };
